// extracted by mini-css-extract-plugin
export var $animation_name = "Newsletter-module--$animation_name--618d4";
export var Error = "Newsletter-module--Error--7df0c";
export var Input = "Newsletter-module--Input--aece8";
export var Input___checkbox = "Newsletter-module--Input___checkbox--b7b19";